import { Injectable } from '@angular/core';

@Injectable()
export class CheckTools {
    public check: any;

    constructor() {
        this.check = new Object();
    }

    public clear() {
        this.setCheck(true, '', '');
    }

    private setCheck(aRes, aMsg, aMsgErr) {
        this.check.res = aRes;
        this.check.msg = aMsg;
        this.check.msgError = aMsgErr;
    }

    public getRes() {
        return this.check.res;
    }

    public getMsg() {
        return this.check.msg;
    }

    public getMsgError() {
        return this.check.msgError;
    }

    public checkFork(aData) {
        for (var prop in aData) {
            this.checkError(aData[prop]);
            if (this.getRes() === false) {
                return;
            }
        }
    }

    public checkError(aResult) {
        this.clear();
        if (aResult === undefined || aResult === null) {
            this.setCheck(false, 'Echec de communication', 'Result undefined');
            return;
        }
        if (aResult === false) {
            this.setCheck(false, 'Echec de communication (false)', 'Result false');
            return;
        }
        if (aResult.status !== undefined) {
            if (aResult.status === false || aResult.status === 500) {
                this.setCheck(false, 'Erreur lors de la récupération des données', this.getErrorMsg(aResult));
            }
            return;
        }
        if (aResult.Status === undefined) {
            this.setCheck(false, 'Echec de communication (server GED)', this.getErrorMsg(aResult));
            return;
        }
        if (aResult.Status === 'ERROR') {
            this.setCheck(false, 'Erreur au niveau du moteur', this.getErrorMsg(aResult));
            return;
        }
    }

    private getErrorMsg(aResult) {
        if (aResult.Message) {
            return aResult.Message;
        } else {
            return '';
        }
    }

}
